import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4c8d0ad4"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8d0ad4')) {
      api.createRecord('4c8d0ad4', component.options)
    } else {
      api.reload('4c8d0ad4', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4c8d0ad4", function () {
      api.rerender('4c8d0ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/list.vue"
export default component.exports